import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              最新动态
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              平台更新、新剧上线、重要公告一手掌握
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-300"></div>

            <div className="flex flex-col gap-6 md:gap-8">
              {updateItems.map((item) => (
                <div key={item.title} className="relative pl-10 md:pl-14">
                  <div className="absolute left-2.5 md:left-3.5 top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>

                  <div className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6">
                    <span className="text-xs text-foreground-400 mb-2 block">
                      {item.date}
                    </span>
                    <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.content}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}